var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 1C1.67157 1 1 1.67157 1 2.5V7.5C1 8.32843 1.67157 9 2.5 9H2V10.707C2 11.152 2.539 11.375 2.854 11.06L4.914 9H9.5C10.3284 9 11 8.32843 11 7.5V2.5C11 1.67157 10.3284 1 9.5 1H2.5ZM3.5 4.25C3.22386 4.25 3 4.47386 3 4.75C3 5.02614 3.22386 5.25 3.5 5.25H8.5C8.77614 5.25 9 5.02614 9 4.75C9 4.47386 8.77614 4.25 8.5 4.25H3.5ZM3.5 6.25C3.22386 6.25 3 6.47386 3 6.75C3 7.02614 3.22386 7.25 3.5 7.25H6.5C6.77614 7.25 7 7.02614 7 6.75C7 6.47386 6.77614 6.25 6.5 6.25H3.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.4d905bd6323b5a07ea030bc915fd8156.svg";
export { ForwardRef as ReactComponent };